import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { MOCKUP_URL } from '../../data/images';
const stats = [['6', 'Volumes'], ['150', 'Ready-to-Teach Lessons'], ['5', 'Practical Bonuses']];

/** Section 14 — the only block with the price and the real checkout button. */
export function CheckoutSection() {
  return <section id="checkout" aria-labelledby="checkout-heading" className="scroll-mt-4 bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-71" data-mp="2mgnpbqii8xmx">
      <div className="mx-auto max-w-4xl rounded-[28px] bg-white px-6 py-12 text-center shadow-[0_50px_100px_-50px_rgba(120,70,80,0.55)] sm:px-12 lg:py-16" data-id="element-72" data-mp="2hfhzc0g8boh3">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-73" data-mp="28fuu13kdpyir">
          Your Next Class Doesn't Have to Start With a Blank Page
        </p>
        <h2 id="checkout-heading" className="mx-auto mt-4 max-w-3xl font-display text-[2.4rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[3.1rem]" data-id="element-74" data-mp="x17u7f1f1cg1">
          You Already Know Nails. <Accent data-id="element-75" data-mp="35gjmodredkw9">Now Give Yourself a System for Teaching Them.</Accent>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-76" data-mp="2rilddmrxoenm">
          Get structured lessons, demonstrations, student practice, correction frameworks,
          assessments and visual teaching resources in one complete Nail Educator library.
        </p>

        <img src={MOCKUP_URL} alt="Nail Educator Ready — six volumes" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-8 block w-full max-w-[520px] object-contain" style={{
        filter: 'drop-shadow(0 22px 26px rgba(120, 96, 56, 0.2))'
      }} data-id="element-77" data-mp="2mjs9mm2g820n" />

        <dl className="mx-auto mt-8 grid max-w-xl grid-cols-3 gap-4 border-y border-brand-charcoal/10 py-6" data-id="element-78" data-mp="23s98kkrziy19">
          {stats.map(([value, label]) => <div key={label} data-id="element-79" data-mp="9csmmmoijsji">
              <dt className="sr-only" data-id="element-80" data-mp="9e3noeqkqm6x">{label}</dt>
              <dd data-id="element-81" data-mp="4l2b4dduayqi">
                <span className="block font-display text-[2.1rem] font-bold leading-none text-brand-charcoal" data-id="element-82" data-mp="4jr506wx9ew8">{value}</span>
                <span className="mt-2 block font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-83" data-mp="3vpitz2yyqlhg">
                  {label}
                </span>
              </dd>
            </div>)}
        </dl>

        <CtaBlock label="Get Nail Educator Ready™ Now" className="mt-9" data-id="element-84" data-mp="nc1sotj0969r" />
        <p className="mt-4 font-body text-[12px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-85" data-mp="n9pfeto6zk31">
          Instant Digital Access • One-Time Payment
        </p>
        <TeachingFlow steps={['Open It', 'Teach It', 'Correct It', 'Assess It']} className="mt-8" data-id="element-86" data-mp="eac19np4i7bz" />
      </div>
    </section>;
}